import { useCallback } from 'react'
import { useBrowserLocation } from 'wouter/use-browser-location'

type NavigateOptions = {
  replace?: boolean
  state?: unknown
}

type LocationHook = () => [
  string,
  (to: string, options?: NavigateOptions) => void,
]

export function createConfirmingLocationHook(
  message: string,
  paths: string[],
): LocationHook {
  const pathsSet = new Set(paths)

  const useConfirmingLocation: LocationHook = () => {
    const [location, baseNavigate] = useBrowserLocation()

    const navigate = useCallback(
      (to: string, options?: NavigateOptions) => {
        const isInGuarded = pathsSet.has('/' + location.split('/').at(-1)!)
        const isChangingRoute = to !== location

        if (isInGuarded && isChangingRoute && !options?.replace) {
          const shouldLeave = window.confirm(message)

          if (!shouldLeave) {
            return
          }
        }

        baseNavigate(to, options as any)
      },
      [location, baseNavigate],
    )

    return [location, navigate]
  }

  return useConfirmingLocation
}
